export default __webpack_public_path__ + "5531ce6710526602bba4b8870bebbf6a.png";